<a
  href="javascript:void(0)"
  class="filter-item-config-icon ml-auto"
  popoverTitle="Select Query Operator"
  placement="bottom"
  [autoClose]="'outside'"
  [ngbPopover]="popover"
  container="body"
>
  <i class="fas fa-cog"></i>
</a>

<ng-template #popover>
  <div class="filter-elements-wrapper">
    <ng-container *ngFor="let operator of operatorsFiltred; let i = index">
      <label class="input-wrap radio" [class.mt-2]="i > 0">
        <input
          type="radio"
          name="operator"
          [(ngModel)]="operatorValue"
          (change)="onRadioChange()"
          [value]="operator.key"
        />
        <span class="text">{{ operator.caption }}</span>
      </label>
    </ng-container>
  </div>
</ng-template>
